// extracted by mini-css-extract-plugin
export default {"wrapper":"GeneralAppError_wrapper__UxpRG","code":"GeneralAppError_code__AFSv8"};